 import ApiService from "@/core/services/api.service"; 
// action types
export const SET_STATE_PRAM = "setStarePram";
export const MANGROE_LNFO_DATA = "mangroveInfo";

export default {
  state: {
    path: "mangroveInfo",
    data_pram:''
  },
  getters: {},
  actions: {
    [MANGROE_LNFO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },

  },
  mutations: {
    [SET_STATE_PRAM](state, payload) {
        state.data_pram = payload;
      },
  }
};
